import { useEffect, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_ALL_OBJECT_PROPERTIES_BY_LIST_ID } from 'automation-ui-enrollment/queries/ObjectPropertiesQueries';
const LIST_DATA_POLL_INTERVAL_MS = 5000;
const SEARCH_QUERY_INITIAL_COUNT = 50;
const SEARCH_QUERY_INITIAL_OFFSET = 0;
const usePollForListData = ({
  listId,
  listSize,
  objectTypeId,
  searchQuery
}) => {
  const [pollingStatus, setPollingStatus] = useState('NOT_STARTED');
  const {
    startPolling: startPollingDataByListId,
    stopPolling: stopPollingDataByListId,
    data: byListIdData,
    loading: byListIdLoading,
    error: byListIdError,
    fetchMore: byListIdFetchMore
  } = useQuery(GET_ALL_OBJECT_PROPERTIES_BY_LIST_ID, {
    variables: {
      objectTypeId,
      listId,
      count: SEARCH_QUERY_INITIAL_COUNT,
      offset: SEARCH_QUERY_INITIAL_OFFSET,
      query: searchQuery
    },
    skip: !listId
  });

  // Begin polling for the list data when we have the list size
  useEffect(() => {
    if (listSize !== undefined) {
      setPollingStatus('POLLING');
      startPollingDataByListId(LIST_DATA_POLL_INTERVAL_MS);
    }
    return () => {
      stopPollingDataByListId();
    };
  }, [listSize, startPollingDataByListId, stopPollingDataByListId]);

  // Listen and wait until the total number of objects is the same as the list size
  useEffect(() => {
    if (byListIdData && listSize !== undefined) {
      if (listSize === byListIdData.allPropertiesByListId.total) {
        setPollingStatus('COMPLETE');
        stopPollingDataByListId();
      }
    }
  }, [listSize, byListIdData, stopPollingDataByListId]);
  return {
    pollingStatus,
    loading: byListIdLoading,
    error: byListIdError,
    data: byListIdData,
    fetchMore: byListIdFetchMore
  };
};
export default usePollForListData;